module.exports = __webpack_public_path__ + "img/mail_sent_icon.5c84f3fd.svg";